<template>
    <button
        type="button"
        @click="openWithdrawDialog(applicationId)"
        class="withdraw-btn text-primary"
        :aria-label="$t('btn_withdraw')"
    >
        <font-awesome-icon icon="fas fa-times"/>
        <span>{{ $t('btn_withdraw') }}</span>
    </button>
    <Dialog
        :modal="true"
        :dismissableMask="true"
        v-model:visible="withdrawDialogIsOpen"
        :showHeader="false"
        class="dialog-rounded-content withdraw-dialog"
    >
        <h2
            class="dialog-title mb-3 text-center"
            :class="isCORSite ? 'text-cor-green' : 'text-eesc-blue-400'"
        >
            <font-awesome-icon icon="fas fa-exclamation-triangle"/>
            {{ $t('lib_alert') }}
        </h2>

        <p class="my-5">
            {{ $t('status_withdrawn_alert') }}
        </p>

        <div class="mt-4 d-flex justify-content-between">
            <button
                type="button"
                @click="withdraw()"
                :disabled="loading"
                class="confirm-withdraw-btn btn btn-lg btn-success px-5 py-1 me-2"
                :aria-label="$t('btn_ok')"
            >
                {{ $t('btn_ok') }}
            </button>
            <button
                type="button"
                @click="closeWithdrawDialog"
                :disabled="loading"
                class="cancel-withdraw-btn btn btn-lg btn-outline-secondary px-5 py-1"
                :aria-label="$t('btn_cancel')"
            >
                {{ $t('btn_cancel') }}
            </button>
        </div>
    </Dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Dialog from 'primevue/dialog';

export default {
    name: 'WithdrawApplicationModal',
    components: {
        Dialog,
    },
    emits: ['withdrawComplete'],
    props: {
        applicationId: {
            required: true,
        },
    },
    data() {
        return {
            withdrawDialogIsOpen: false,
            loading: false,
        };
    },
    computed: {
        ...mapGetters(['isCORSite']),
    },
    methods: {
        ...mapActions(['withdrawApplication']),
        openWithdrawDialog() {
            this.withdrawDialogIsOpen = true;
        },
        closeWithdrawDialog() {
            this.withdrawDialogIsOpen = false;
        },
        withdraw() {
            this.loading = true;
            this.withdrawApplication(this.applicationId).then(
                () => {
                    this.$emit('withdrawComplete');
                    this.closeWithdrawDialog();
                    this.$toast.add({
                        severity: 'success',
                        detail: 'Withdraw action complete!',
                        life: 3000,
                    });
                    this.loading = false;
                },
                () => {
                    this.$toast.add({
                        severity: 'error',
                        detail: this.$t('lib_action_failed', [
                            this.$t('btn_withdraw').toLowerCase(),
                        ]),
                        life: 3000,
                    });
                    this.loading = false;
                }
            );
        },
    },
};
</script>
